import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../../utils";

export const instituteOnboardingList = createAsyncThunk('instituteOnboardingList', async ({ pageable: data, navigate }) => { try { const res = await axios({ method: 'GET',
            url: getConfig.API_URL + `instiute_onboarding`,
            params: { 'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) { return error.response
    }
})

const instituteOnboardingListSlice = createSlice({ name: 'instituteOnboardingList',
    initialState: { data: [] },
    extraReducers: (builder) => { builder.addCase(instituteOnboardingList.fulfilled, (state, action) => { if (action?.payload?.status === 200) { state.data = (() => { const raw = action.payload?.data?.data; if (Array.isArray(raw)) return raw; if (Array.isArray(raw?.getInstituteOnboardingList)) return raw.getInstituteOnboardingList; return Object.values(raw || {}).find(Array.isArray) || []; })();
            } else if (action?.payload?.status === 401 && !action.meta.arg?.silent) { showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403 && !action.meta.arg?.silent) { showAccessDeniedAlert(action.meta.arg.navigate)
            } else { state.data = []
            }
        });
    }
})

export default instituteOnboardingListSlice.reducer;
